// Re-export of JsonViewer with some default styles
import { JsonViewer, JsonViewerProps } from "@textea/json-viewer";

export const JSONViewer = (props: JsonViewerProps) => {
  return (
    <div className="whitespace-pre-wrap">
      <JsonViewer
        defaultInspectDepth={0}
        enableClipboard={false}
        displayDataTypes={false}
        indentWidth={2}
        quotesOnKeys={false}
        collapseStringsAfterLength={false}
        displaySize={false}
        {...props}
      />
    </div>
  );
};
